import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { IFeatureToggle } from 'app/models/feature-toggle.model';
import { AuthenticationTokenStorageService } from '../session-storage/authentication.token.storage.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly authenticationTokenStorageService: AuthenticationTokenStorageService
  ) { }

  getFeatureToggle(code: string): Promise<IFeatureToggle> {
    const { customerId } =
      this.authenticationTokenStorageService.getLoggedUser();
      return this.http
        .get<IFeatureToggle>(`${this.constants.FEATURE_TOGGLE_ENDPOINT}/code/${code}/customer/${customerId}`)
        .toPromise()
        .catch(error => {
          console.error('Error during feature toggle loading', error);
          return {
            enabled: false,
          };
        });
  }
}
